import React from 'react'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import CommonTable from '../../components/CommonTable'
import TrackerNote from '../../components/TrackerNote'

const ApplicationDetails = () => {
  const { applicationDetails, isLoading } = useSelector((state) => state.application)

  if (isLoading) {
    return <Spin size="large" />
  }

  if (!applicationDetails) {
    return <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>No data available</div>
  }

  const dataSource = [
    {
      key: '1',
      field: 'Application Name',
      value: applicationDetails.applicationName || 'N/A',
    },
    {
      key: '2',
      field: 'Application APM ID',
      value: applicationDetails.applicationAPMID || 'N/A',
    },
    {
      key: '3',
      field: 'UMID',
      value: applicationDetails.uami || applicationDetails.umid || applicationDetails.UMID || 'N/A',
    },
    {
      key: '4',
      field: 'Application Classification',
      value: applicationDetails.appCategory || applicationDetails.applicationClassification || applicationDetails.classification || 'N/A',
    },
    {
      key: '5',
      field: 'Technology Stack',
      value: applicationDetails.technologyStack || applicationDetails.techStack || 'N/A',
    },
    {
      key: '6',
      field: 'Functional Owner',
      value: applicationDetails.functionalOwner || 'N/A',
    },
    {
      key: '7',
      field: 'TL (Team Lead)',
      value: applicationDetails.technicalLead || applicationDetails.teamLead || applicationDetails.TL || 'N/A',
    },
    {
      key: '8',
      field: 'Portfolio Sponsor',
      value: applicationDetails.portFolioSponsor || applicationDetails.portfolioSponsor || 'N/A',
    },
    {
      key: '9',
      field: 'Project Manager',
      value: applicationDetails.projectManager || 'N/A',
    },
    {
      key: '10',
      field: 'Business Analyst',
      value: applicationDetails.businessAnalyst || 'N/A',
    },
    {
      key: '11',
      field: 'Quality Analyst',
      value: applicationDetails.qualityAnalyst || 'N/A',
    },
    {
      key: '12',
      field: 'Developer',
      value: applicationDetails.developer || 'N/A',
    },
    {
      key: '13',
      field: 'Secondary Developer',
      value: applicationDetails.secondaryDeveloper || 'N/A',
    },
    {
      key: '14',
      field: 'Application URL',
      value: applicationDetails.applicationURL ? (
        <a href={applicationDetails.applicationURL} target="_blank" rel="noopener noreferrer">
          {applicationDetails.applicationURL}
        </a>
      ) : (
        'N/A'
      ),
    },
  ]

  const columns = [
    {
      title: 'Field',
      dataIndex: 'field',
      key: 'field',
      width: '30%',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
    },
  ]

  return (
    <>
      <TrackerNote
        text="To update application details please update tracker -"
        linkLabel="Azure Applications - All Items"
        href="https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fsites.ey.com%2Fsites%2Finapps%2FLists%2FAzure%2520Applications%2FAllItems.aspx&data=05%7C02%7CKallol.Roy%40bd.ey.com%7Cc003e2851a714266789008df196804a7%7C5b973f9977df4bebb27daa0c70b8482c%7C0%7C0%7C639257606674018694%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=5%2Bd8%2F5wtyHn8ryr2gyKQcn22%2BltV9njt1Kww2i%2FFh5c%3D&reserved=0"
      />
      <CommonTable
        columns={columns}
        dataSource={dataSource}
        rowKey="key"
        pagination={false}
      />
    </>
  )
}

export default ApplicationDetails
